import { useState } from "react";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import { useNavigate } from "react-router-dom";
import { AddUserModal, EditTeamModal } from "entitites/teams/ui";
import { Typography } from "@mui/material";
import { useGetMyRolesQuery } from "entitites/casdoor/api/casdoorApi";

export const TeamPageHeaderGrid = ({
  teamName,
  teamId,
  teamLeadId,
  teamLeadName,
}: {
  teamName: string;
  teamId: string;
  teamLeadId: string;
  teamLeadName: string;
}) => {
  const { data: roles } = useGetMyRolesQuery();
  const [open, setOpen] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const navigate = useNavigate();
  return (
    <Box bgcolor="white" borderRadius="4px 4px 0px 0px">
      <Box p="15px" fontWeight={700} fontSize="20px">
        <span
          style={{ cursor: "pointer", color: "#9696E2" }}
          onClick={() => navigate("/teams")}
        >
          Команды {">"}
        </span>{" "}
        {teamName}
      </Box>
      <Box
        borderRadius="4px"
        p="15px"
        display="flex"
        gap={1.5}
        alignItems="center"
      >
        <Typography fontSize="18px">
          <strong>Руководитель:</strong> {teamLeadName}
        </Typography>
        <AddUserModal
          teamId={teamId}
          open={open}
          handleClose={() => setOpen(false)}
        />
        {teamName && (
          <EditTeamModal
            teamId={teamId}
            teamLead={teamLeadId}
            name={teamName}
            open={openEdit}
            handleClose={() => setOpenEdit(false)}
          />
        )}
        {Boolean(roles?.includes("staffdesk-admin")) && (
          <>
            <Button
              disableElevation
              onClick={() => setOpen(true)}
              sx={{
                textTransform: "none",
                minWidth: 186,

                ml: "auto",
                fontWeight: 700,
                height: "40px",
              }}
              variant="contained"
              // size="small"
            >
              Добавить нового участника +
            </Button>
            <Button
              disableElevation
              onClick={() => setOpenEdit(true)}
              sx={{
                textTransform: "none",
                minWidth: 186,
                fontWeight: 700,
                height: "40px",
              }}
              variant="contained"
              // size="small"
            >
              Редактировать команду
            </Button>
          </>
        )}
      </Box>
    </Box>
  );
};
